let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ckbna")).then(() => parcelRequire('6wpE3'));